module.exports = __webpack_public_path__ + "static/media/score_result_3.7fff0d2b.png";